import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getEFillList = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/efill/form/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createEFill = ({ version = 'v1', payload, params = {} } = {}) =>
  client
    .request({
      url: `${version}/efill/form/`,
      method: RequestMethod.POST,
      params,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateEFill = ({
  version = 'v1',
  payload,
  formId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/form/${formId}/`,
      method: RequestMethod.PUT,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const linkFormToParent = ({
  version = 'v1',
  formId,
  payload,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/form/${formId}/link/`,
      method: RequestMethod.PUT,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFormSync = ({ version = 'v1', formId, params = {} } = {}) =>
  client
    .request({
      url: `${version}/efill/form/sync/${formId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateFormSync = ({
  version = 'v1',
  formId,
  payload,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/form/sync/${formId}/`,
      method: RequestMethod.PUT,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEFillResponsibleParties = ({
  version = 'v1',
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/responsible-parties/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const duplicateForm = ({ version = 'v1', formId, params = {} } = {}) =>
  client
    .request({
      url: `${version}/efill/form/${formId}/duplicate/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFormInstance = ({
  version = 'v1',
  formInstanceId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/instance/${formInstanceId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFormTemplateDetails = ({
  version = 'v1',
  formInstanceId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/instance/${formInstanceId}/template/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateFormInstance = ({
  version = 'v1',
  formInstanceId,
  payload,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/instance/${formInstanceId}/`,
      method: RequestMethod.PUT,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteFormInstance = ({
  version = 'v1',
  formInstanceId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/instance/${formInstanceId}/`,
      method: RequestMethod.DELETE,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPlacementAssignedForms = ({
  version = 'v1',
  placementId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/ip-program-management/placement-forms/${placementId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProgramAssignedForms = ({
  version = 'v1',
  programId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/ip-program-management/program-forms/${programId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const submitResponses = ({
  version = 'v1',
  formInstanceId,
  payload,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/efill/instance/${formInstanceId}/user-step/`,
      method: RequestMethod.PUT,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
